import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FlameSantander from '../Icons/FlameSantander'
import styles from './headerExternalLayout.module.scss'

const HeaderExternalLayout = (props) => {
  const { title, subtitle, description, className } = props

  const containerClasses = classNames(styles.contaer, className, {})

  return (
    <div className={containerClasses}>
      <div className={styles.container}>
        <FlameSantander className={styles.logoSantander} />
        <h2 className={styles.title}>{title}</h2>
        <h3 className={styles.subtitle}>{subtitle}</h3>
        <h3 className={styles.subtitle}>{description}</h3>
      </div>
    </div>
  )
}

HeaderExternalLayout.defaultProps = {
  className: null,
  description: null
}

HeaderExternalLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string
}

export default HeaderExternalLayout
